module.exports = __webpack_public_path__ + "img/lucky5_bg.6f8ab051.png";